import { render, staticRenderFns } from "./ClippingMenu.vue?vue&type=template&id=57630817&scoped=true&"
import script from "./ClippingMenu.vue?vue&type=script&lang=js&"
export * from "./ClippingMenu.vue?vue&type=script&lang=js&"
import style0 from "./ClippingMenu.vue?vue&type=style&index=0&id=57630817&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57630817",
  null
  
)

export default component.exports